import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { PageHeader, Card } from "./ui";
import { toast } from "sonner";

const FIELDS = [
  ["hero_title", "Hero titel", "input"],
  ["hero_subtitle", "Hero subtitel", "input"],
  ["hero_intro", "Hero introtekst", "textarea"],
  ["brand_story", "Merkverhaal", "textarea"],
  ["statement_heading", "Statement-heading", "input"],
  ["whatsapp_number", "WhatsApp nummer", "input"],
  ["whatsapp_button_label", "WhatsApp knoptekst", "input"],
  ["whatsapp_default_message", "WhatsApp standaardbericht", "textarea"],
  ["sales_email", "Sales e-mail", "input"],
  ["phone_public", "Telefoon (publiek)", "input"],
  ["terms_content", "Algemene voorwaarden", "textarea"],
  ["privacy_content", "Privacybeleid", "textarea"],
];

export default function Settings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return <p className="text-white/50">Laden...</p>;

  const save = async () => { try { await api.put("/admin/settings", s); toast.success("Instellingen opgeslagen"); } catch (e) { toast.error(apiErr(e)); } };
  const inp = "w-full rounded-xl border border-white/10 bg-sfc-night px-3 py-2.5 text-sm text-white focus:border-sfc-orange focus:outline-none";

  return (
    <div>
      <PageHeader title="Site-instellingen" subtitle="Beheer teksten, contact en juridische pagina's" />
      <Card className="p-6">
        <div className="grid gap-5 md:grid-cols-2">
          {FIELDS.map(([k, label, type]) => (
            <label key={k} className={type === "textarea" ? "md:col-span-2 block" : "block"}>
              <span className="mb-1.5 block text-xs uppercase tracking-wider text-white/50">{label}</span>
              {type === "textarea"
                ? <textarea data-testid={`setting-${k}`} rows={3} className={inp} value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} />
                : <input data-testid={`setting-${k}`} className={inp} value={s[k] || ""} onChange={(e) => setS({ ...s, [k]: e.target.value })} />}
            </label>
          ))}
        </div>
        <button data-testid="save-settings-btn" onClick={save} className="mt-8 rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-8 py-3 text-sm font-semibold text-white">Opslaan</button>
      </Card>
    </div>
  );
}
